<mat-toolbar class="page-header"> <span>Payment Required</span> </mat-toolbar>
<div class="no-subscription-container">
  <p>
    Access to the Kahi platform is limited until successful payment is processed to restore the account in good standing.
  </p>
  <a mat-raised-button color="primary" routerLink="/billing/subscription" *ngIf="hasSubscriptionPrivilege">Manage subscription</a>
  <p *ngIf="!hasSubscriptionPrivilege">
    Contact your organization owner or manager to resolve any billing issues.
  </p>
</div>